import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserService } from '../../core/services/user.service';
import { MyStudentService } from '../my-students/my-students.service';

@Injectable({
  providedIn: 'root'
})
export class StudentOwnershipGuard implements CanActivate {
  private userService = inject(UserService);
  private studentService = inject(MyStudentService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Ensure user is fully loaded before checking ownership
    if (!this.userService.isInitialized()) {
      await this.userService.loadClaims();
    }

    // Check both path params and query params for studentId
    const studentId = route.params['studentId'] || route.queryParams['studentId'];

    // If no studentId in either params or query params, allow access (optional student parameter)
    if (!studentId) {
      return true;
    }

    const currentUser = this.userService.currentUser();

    // Since user should be loaded at app startup, this means auth issue
    if (!currentUser || !currentUser.uid) {
      console.warn('No valid user found for student ownership check');
      this.router.navigate(['/not-found']);
      return false;
    }

    try {
      // Check if the requested student belongs to the user
      const ownsStudent = await this.studentService.ownsStudent(studentId);
      
      if (!ownsStudent) {
        // Student doesn't belong to this user - show 404
        console.warn(`Unauthorized access attempt: Student ${studentId} not owned by user ${currentUser.uid}`);
        this.router.navigate(['/not-found']);
        return false;
      }
      
      return true;
      
    } catch (error) {
      console.error('Error checking student ownership:', error);
      // On error, deny access and show 404
      this.router.navigate(['/not-found']);
      return false;
    }
  }
}